import {Provider} from '@angular/core';
import {AuthController} from '@core/auth/auth.controller';
import {
  VerifyAuthUseCaseProvider
} from '@features/auth/presentation/providers/verify-auth/verify-auth.use-case.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';

export const AuthControllerProvider: Provider[] = [
  VerifyAuthUseCaseProvider,
  LocalStorageAdapterProvider,
  NavigationAdapterProvider,
  AuthController
];
